/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Reset_Code_DigitsInputs */

const en_password_reset_code_digits = /** @type {(inputs: Password_Reset_Code_DigitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code must contain digits only`)
};

const es_password_reset_code_digits = /** @type {(inputs: Password_Reset_Code_DigitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El código debe contener solo dígitos`)
};

/**
* | output |
* | --- |
* | "Code must contain digits only" |
*
* @param {Password_Reset_Code_DigitsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const password_reset_code_digits = /** @type {((inputs?: Password_Reset_Code_DigitsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Reset_Code_DigitsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_password_reset_code_digits(inputs)
	return en_password_reset_code_digits(inputs)
});